import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTreeChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 2C2.7835 2 2 2.7835 2 3.75V20.25C2 21.2165 2.7835 22 3.75 22H20.25C21.2165 22 22 21.2165 22 20.25V3.75C22 2.7835 21.2165 2 20.25 2H3.75ZM3.5 3.75C3.5 3.61193 3.61193 3.5 3.75 3.5H20.25C20.3881 3.5 20.5 3.61193 20.5 3.75V20.25C20.5 20.3881 20.3881 20.5 20.25 20.5H3.75C3.61193 20.5 3.5 20.3881 3.5 20.25V3.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 7.65C11 7.29101 11.1847 7 11.4125 7H21.5875C21.8153 7 22 7.29101 22 7.65C22 8.00899 21.8153 8.3 21.5875 8.3H11.4125C11.1847 8.3 11 8.00899 11 7.65Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 11.8502C2 11.4912 2.16789 11.2002 2.375 11.2002H11.625C11.8321 11.2002 12 11.4912 12 11.8502C12 12.2092 11.8321 12.5002 11.625 12.5002H2.375C2.16789 12.5002 2 12.2092 2 11.8502Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.65 3C12.009 3 12.3 3.30221 12.3 3.675L12.3 20.325C12.3 20.6978 12.009 21 11.65 21C11.2911 21 11 20.6978 11 20.325L11 3.675C11 3.30221 11.2911 3 11.65 3Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2499 7C16.6089 7 16.8999 7.23505 16.8999 7.525L16.8999 20.475C16.8999 20.7649 16.6089 21 16.2499 21C15.8909 21 15.5999 20.7649 15.5999 20.475L15.5999 7.525C15.5999 7.23505 15.8909 7 16.2499 7Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 15.65C16 15.291 16.1007 15 16.225 15H21.775C21.8993 15 22 15.291 22 15.65C22 16.009 21.8993 16.3 21.775 16.3H16.225C16.1007 16.3 16 16.009 16 15.65Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgTreeChart;
